import {IMAGE_TYPES_WITH_DATE} from './imageTypeUtils'

export const DEFAULT_IMAGE_LAYER_LOAD_STATE = {
  status: 'idle',
  requestKey: null,
  retryVersion: 0,
  errorType: null,
}

export const markImageLayerReady = (stateByLand, landId, requestKey) => {
  const current = stateByLand[landId] || DEFAULT_IMAGE_LAYER_LOAD_STATE

  if (current.status === 'ready' && current.requestKey === requestKey) {
    return stateByLand
  }

  if (current.status === 'loading' && current.requestKey !== requestKey) {
    return stateByLand
  }

  return {
    ...stateByLand,
    [landId]: {
      ...current,
      status: 'ready',
      requestKey,
      errorType: null,
    },
  }
}

export const resetImageLayerLoadState = (stateByLand, landId) => {
  const current = stateByLand[landId]

  if (!current) {
    return stateByLand
  }

  if (
    current.status === 'idle' &&
    current.requestKey == null &&
    current.errorType == null &&
    current.retryVersion === 0
  ) {
    return stateByLand
  }

  return {
    ...stateByLand,
    [landId]: DEFAULT_IMAGE_LAYER_LOAD_STATE,
  }
}

export const shouldShowImageLayerRetry = (imageType, loadState) => (
  IMAGE_TYPES_WITH_DATE.has(imageType) && loadState?.status === 'error'
)
